/**
 * @generated SignedSource<<0923056101e11787274c42c0ce6cb69e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseModalContainer_photo$data = {
  readonly name: string | null;
  readonly path: string | null;
  readonly room: {
    readonly name: string | null;
    readonly urlLabel: string | null;
    readonly value: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly styles: ReadonlyArray<{
    readonly name: string | null;
    readonly urlLabel: string | null;
    readonly value: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"PhotoRailContainer_searchBrowsePhoto" | "PhotosSearchBrowseFirmDetailsRenderer_searchBrowsePhoto" | "interiorsPhotosTracking_searchBrowsePhoto">;
  readonly " $fragmentType": "PhotosSearchBrowseModalContainer_photo";
};
export type PhotosSearchBrowseModalContainer_photo$key = {
  readonly " $data"?: PhotosSearchBrowseModalContainer_photo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseModalContainer_photo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseModalContainer_photo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotosSearchBrowseFirmDetailsRenderer_searchBrowsePhoto"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotoRailContainer_searchBrowsePhoto"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "interiorsPhotosTracking_searchBrowsePhoto",
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineDataFragmentSpread",
          "name": "getShoppablePhotoData_searchBrowsePhoto",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradePhotoTag",
              "kind": "LinkedField",
              "name": "tags",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "getShoppablePhotoData_tags",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SimilarItemsResults",
                      "kind": "LinkedField",
                      "name": "similarItems",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Item",
                          "kind": "LinkedField",
                          "name": "items",
                          "plural": true,
                          "selections": (v1/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PhotoCreator",
              "kind": "LinkedField",
              "name": "creators",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "getShoppablePhotoData_creators",
                  "selections": [
                    {
                      "alias": "photoCreatorItems",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 4
                        }
                      ],
                      "concreteType": "Item",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": (v1/*: any*/),
                      "storageKey": "items(first:4)"
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhotoStyle",
      "kind": "LinkedField",
      "name": "styles",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhotoStyle",
      "kind": "LinkedField",
      "name": "room",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v2/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowsePhoto",
  "abstractKey": null
};
})();

(node as any).hash = "99f64e3289315fd397b22c1a8cac1f33";

export default node;
